$ = require 'jquery'
Alerts = require 'app/scripts/views/lib/alerts'
Auth = require 'app/scripts/db/auth'
PopOver = require 'app/scripts/views/lib/pop-over'
Util = require 'app/scripts/lib/util'
View = require 'app/scripts/views/internal/view'
templates = require 'app/scripts/views/internal/templates'
l = require 'app/scripts/lib/localize'

module.exports = class EmojiUploaderView extends View
  viewTitleKey: 'upload emoji'

  events: ->
    'click .js-upload-emoji': 'uploadEmoji'
    'change .js-upload-emoji-file': 'fileChange'
    'input .js-emoji-name': 'nameChange'

  initialize: ({ @completerView }) ->
    @hasGold = @model.isFeatureEnabled('customEmoji')
    @hasBCGold = false

    for org in @model.organizationList.models
      @hasBCGold = org.isFeatureEnabled('goldMembers')
      break if @hasBCGold

  render: ->
    view = @
    data = @model.toJSON()
    data.emojiName = @options.emojiName
    data.hasGold = @hasGold
    data.hasBCGold = @hasBCGold
    data.canUpload = @hasGold || @hasBCGold

    @$el.html(
      templates.fill(
        require('app/scripts/views/templates/popover_emoji_uploader'),
        data
      )
    )

    @_validate()
    @renderEmoji()

    @

  getName: ->
    @$('.js-emoji-name').val().trim().toLowerCase().replace(/\s+/g, "_")

  renderEmoji: ->
    @$('.js-emoji-preview-name').text(":#{ @getName() || "???" }:")

    $emoji = @$('.js-emoji-preview')

    $file = @$('.js-upload-emoji-file')
    file = $file.prop('files')?[0]
    if /// ^image/.* ///.test(file?.type)
      reader = new FileReader()
      reader.onload = (file) =>
        @$('.js-emoji-conversion').removeClass('hide')
        @$('.js-emoji-preview').attr('src', file.target.result)
      reader.readAsDataURL(file)
    else
      @$('.js-emoji-conversion').addClass('hide')

    @

  fileChange: (e) ->
    $name = @$('.js-emoji-name')
    $file = @$('.js-upload-emoji-file')
    if $name.val() == ""
      input = $(e.target)
      file = $file.prop('files')?[0]
      if file?
        name = file.name
      else if $file.val()
        # Proably IE, try to get the file from the path
        name = /// [^\/]+$ ///.exec($file.val())?[0]

      name ?= ""
      name = name.split('.')[0] # Remove the extension(s)
      name = name.toLowerCase().replace(/[^a-z0-9_]/g, "")

      $name.val(name)
      @$('.js-emoji-name').focus().select()

    @renderEmoji()
    @_validate()

  nameChange: (e) ->
    @renderEmoji()
    @_validate()

  _validate: (e) ->
    name = @getName()

    $file = @$('.js-upload-emoji-file')

    nameValid = /^[a-z0-9_\s]+$/.test(name)
    fileValid = $file.prop('files')?.length > 0 || $file.val()
    valid = nameValid && fileValid && (@hasGold || @hasBCGold)

    @$('.js-invalid-name').toggleClass('hide', nameValid || name == "")
    @$('.js-upload-emoji').toggleClass('disabled', !valid)

  uploadEmoji: (e) ->
    Util.stop(e)
    return if $('.js-upload-emoji').hasClass('disabled')

    @$('.error').addClass('hide')

    $file = @$('.js-upload-emoji-file')
    file = $file.prop('files')?[0]
    name = @getName()

    onSuccess = =>
      @completerView.insertEmoji(name)
      PopOver.hide()

    if !file && $file.val()
      # Yuck, it's IE.  Let's submit the form.
      Util.uploadFile Auth.myToken(), $file, onSuccess
      return

    if file? && !Util.validFileSize(file)
      Alerts.flash('file too large', 'error')
      return

    if !file? || !name
      return

    reader = new FileReader()
    fd = new FormData()
    fd.append('token', Auth.myToken())
    fd.append('file', file)
    fd.append('name', name)

    reader.onload = (file) =>
      @model.customEmojiList.create {
        url: file.target.result
        name: name
      }, {
        data: fd
        processData: false
        contentType: false
        success: onSuccess
        error: ->
          @$('.error').removeClass('hide')
      }

    reader.readAsDataURL(file)
